import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import checkImg from "../assets/icons/check_circle.png";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function EditInputDialog({
  title,
  text,
  contentMsg,
  formName,
  type,
  closeDialog,
  errMsg,
  editDialog,
  doneButton
}) {
  

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [textFieldValue, setTextFieldValue] = useState(formName);
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleDone = (textFieldValue) => {
    if (textFieldValue.trim() === "") {
      setErrorMsg(errMsg);
      return;
    }

    setOpen(false);
    editDialog && editDialog(textFieldValue);
  };

  const handleTextFieldChange = (event) => {
    if (event.target.value.trim() !== "") setErrorMsg("");
    setTextFieldValue(event.target.value);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            {title}
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Typography variant="h3" style={{ fontSize: 16, paddingBottom: 10 }}>
            {text}
          </Typography>
          <DialogContentText id="alert-dialog-description">          
            <TextField
              //className={classes.textFieldStyle}
              fullWidth
              autoFocus
              label={contentMsg}
              margin="normal"
              name="name"
              variant="outlined"
              id="name"
              value={textFieldValue}
              onChange={handleTextFieldChange}
              onKeyDown={(e) => {
                e.key === "Enter" && handleDone(textFieldValue);
              }}
            />
            {errorMsg && (
              <Box ml={2}>
                <FormHelperText className={classes.errorStyle} error>
                  {errorMsg}
                </FormHelperText>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={() => handleDone(textFieldValue)}
            >
              {doneButton ? doneButton : "Done"}
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
